/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Cmspost_Error_Category_In_Use1Inputs */

const vi_cmspost_error_category_in_use1 = /** @type {(inputs: Cmspost_Error_Category_In_Use1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Chuyên mục đang có ${i?.count} bài (kể cả bài nháp) — chuyển các bài đó sang chuyên mục khác trước khi xoá.`)
};

/**

* @param {Cmspost_Error_Category_In_Use1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspost_error_category_in_use1 = /** @type {((inputs: Cmspost_Error_Category_In_Use1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspost_Error_Category_In_Use1Inputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspost_error_category_in_use1(inputs)
});
export { cmspost_error_category_in_use1 as "cmsPost_error_category_in_use" }